//病人管理模块

//引入接口文档
import req from '@/utils/req.js'


//病人管理列表数据
export function api_patientlist(params) {
    return req.post("/admin/patient/page",params);
}


//病人管理列表数据
export function api_patientarchives(id) {
    return req.get( `/admin/patient-archives/${id}/patient`);
}

//病人档案事件列表
export function api_archives_event(params) {
    return req.get( "/admin/archives-event/page",params);
}

//病人病历列表
export function api_medical_case(params) {
    return req.get( "/admin/medical-case/page",params);
}

//病人处方列表
export function api_prescription(params) {
    return req.get( "/admin/prescription/page",params);
}


//医护团队下拉框 数据
export function api_doctor_team(params) {
    return req.get( "/admin/doctor-team",params);
}


//疗程主管下拉框 数据
export function api_depart_tree(params) {
    return req.post( "/admin/department/tree-list",params);
}


//病人档案列表
export function api_get_web_patient(params) {
    return req.get( "/admin/archives-event/web/patientId",params);
}
//护理服务类型列表查询
export function associateList(params) {
    return req.get( "/admin/nursing-type/associateList",params);
}
//分配医护上面服务
export function distribute(params) {
    return req.post( "/admin/doctor-nursing/distribute",params);
}
//病人分组列表
export function groupList(params) {
    return req.post( "/admin/patient-group/page/v2",params);
}
//创建分组
export function creatGroup(params) {
    return req.post( "/admin/patient-group/v2",params);
}
//更新分组
export function upGroup(params) {
    return req.put( "/admin/patient-group/v2",params);
}
//更新分组患者
export function updatePatients(params) {
    return req.get( "/admin/patient-group/updatePatientsByGroupId",params);
}
//病人分组详情
export function groupDetails(params) {
    return req.get( `/admin/patient-group/${params}`,{});
}

//病人列表
export function detailPageList(params) {
    return req.post( "/admin/patient-group/detailPage",params);
}

//病人列表
export function getPatientLabelPage(params) {
    return req.post( "/admin/patient-label/page",params);
}

//导出病人列表
export function exportPatientsInfo(params) {
    return req.postUpload( "/admin/patient-group/exportPatientsInfo",params,{ responseType:'arraybuffer' });
}

//消息模板
export function templateList(params) {
    return req.post("/admin/patient-group/templatePage",params);
}
//创建消息模板
export function cretaedTemplate(params) {
    return req.post("/admin/patient-group/template",params);
}
//消息模板详情
export function templateDetail(id) {
    return req.get(`/admin/patient-group/templateDetail/${id}`,{});
}
// 群发消息
export function sendMess(params) {
    return req.post("/admin/patient-group/send",params);
}

// 保存患者亲属
export function saveOrUpdatePatientRelative(params) {
  return req.post("/admin/patient-relative/saveOrUpdatePatientRelative",params);
}

//根据患者id查询患者亲属详情
export function getRelativeByPatientId(params) {
  return req.get("/admin/patient-relative/getRelativeByPatientId",params);
}
//标签列表
export function getTaglist(params) {
    return req.get("/admin/patient-group/queryTagList?tagName="+params);
}
//患者分组启用禁用
export function groupEnable(params) {
    return req.post("/admin/patient-group/enable",params);
}
// 患者分组历史记录
export function groupHistory(params) {
    return req.post("/admin/patient-group/history",params);
}
//消息计划列表
export function planList() {
    return req.get("/admin/push-package/listForDropList",{});
}
//设置群发消息
export function fanoutMsg(params) {
    return req.post("/admin/patient-group/fanoutMsg",params);
}
//群发消息详情
export function fanoutMsDetails(params) {
    return req.get("/admin/patient-group/queryFanoutMsgDetail",params);
}

//根据标签自动更新标签用户信息
export function automaticUpdatePatientLabel(labelId) {
    return req.post( `/biz/label-rule/automaticUpdatePatientLabel?labelId=${labelId}`);
}



export function myFilesItemPage(params) {
    return req.post("/admin/patient-files-item/myFilesGetPatientFilesItemPage",params);
}
// 录入分组 
export function inputGroup(params) {
    return req.post("/admin/patient-input-group/page",params);
}

//获取指定用户关联的标签列表(远程调用中台接口)
export function queryUserLabelNameByPatientId(params) {
  return req.get( `/admin/patient-label/remote/queryLabelNameByPatientId/${params}`);
}

//获取指定患者的推送记录
export function queryPushListByPatientId(params) {
  return req.get( `/dsicm-api/feign/push-package/queryPushListByPatientId/${params}`);
}

// 终止指定用户的指定推送服务包 
export function stopPushPlanForPatient(params) {
  return req.post("/dsicm-api/feign/push-package/stopPushPlanForPatient",params);
}

// 疾病类型列表查询(隐藏通用) 
export function findDiseaseTypeByAdmin(params) {
  return req.get("/admin/disease-type/findDiseaseTypeByAdmin",params);
}


// 获取指定患者的推送记录 
export function queryPatientPushList(params) {
  return req.post("/admin/push-package/queryPatientPushList",params);
}

// 获取指定患者的推送记录->推送服务包查询
export function queryPushJobList(params) {
  return req.get( `/admin/push-package/queryPushJobListForPushPackage/${params}`);
}

// 患者档案查询-杭州
export function selectByPatientIdAndHospitalId(params) {
  return req.get( `/admin/patient-archives-third-party/selectByPatientIdAndHospitalId`,params);
}

// 补卡申请 
export function reapplyVipCard(params) {
  return req.post("/admin/membership-card-apply/reapply",params);
}


// 获取最新的补卡记录 
export function newReapplyRecord(params) {
  return req.get("/admin/membership-card-apply/reapplyRecord",params);
}

// 患者档案修改 
export function updateCustome(params) {
  return req.put("/admin/patient-archives-third-party",params);
}

// dsicm 标签查询 
export function getDsicmGroupPage(params) {
  return req.post("/admin/label-database/groupPage",params);
}

// 导出用户标签
export function exportPatientLabel(labelId) {
  return req.postUpload(`/admin/patient-label/export/patientLabel?labelId=${labelId}`, {}, { responseType:'arraybuffer' });
}

// 删除用户标签
export function deletePatientLabel(id) {
  return req.delete(`/admin/patient-label/${id}`);
}
